import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'
import {PieChart, Pie} from 'recharts';
import ConditionsChart from './ConditionsChart'

class PlayersStatsWindow extends StatsBaseWindow {

  static propTypes = {
      top: React.PropTypes.number,
      left: React.PropTypes.number,
      home: React.PropTypes.bool.isRequired
  }

  static defaultProps = {
    top: 10,
    left: 10,
  }

  render() {
        const { close_stats_window } = this.props.StatisticActions;
        
        return (<PopupWindow header={this.props.teamName+ ': Игроки'} width={300} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <table className="players_stats_table">
                      <thead>
                        <tr>
                          <th title="Номер">No</th>
                          <th title="Статус">Ст</th>
                          <th title="Капитан">К</th>
                          <th title="Имя">Имя</th>
                          <th title="Кондиции">Конд</th>
                          <th title="Оценка">Оцн</th>
                          <th title="Голы">Гол</th>
                          <th title="Голевые передачи">ГП</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.props.players.map((player, i) =>
                              <tr key={i} className={i<11 && !player.Stats.HasRedCard && !player.Injured ?"stat-start":"stat-subs"}>

                                <td><div className={"number player_shape "} style={{background: this.props.back, color:this.props.playerColor, borderColor:this.props.borderColor}}>{player.Number}</div></td>
                                <td className="subs-col">
                                    <div className={player.Stats.SubIn>0?"sub-in":"no-sub"}>{player.Stats.SubIn}</div>
                                    <div className={player.Stats.SubOut>0?"sub-out":"no-sub"}>{player.Stats.SubOut}</div>
                                </td>
                                <td className={player.captain?"captain-col player_shape":""}>{player.captain?"C":""}</td>
                                <td className="stat_player_name">
                                    <div
                                        className={"cardStats "+(player.Stats.HasYellowCard?"hasYellowCard ":" ")
                                        + (player.Stats.HasRedCard?"hasRedCard ":" ")
                                        + (player.Stats.HasYellowCard && player.Stats.HasRedCard?"hasSecondYellowCard ":" ")}/>
                                    <span className="name center">{player.Name.LastName}</span>
                                    {
                                        player.Injured &&
                                            <span className="injured"></span>
                                    }
                                </td>
                                <td className="conditions-col">
                                    <div className="conditions center">
                                        <div title="Усталость" className="conditions-graph">
                                            <ConditionsChart fatigue={player.Stats.Fatigue}/>
                                        </div>
                                        <div title="Форма" className="conditions-number">
                                            {player.Stats.Conditions}
                                        </div> 
                                    </div>
                                </td>
                                <td><div className="raiting center">{player.Stats.Raiting != null ? player.Stats.Raiting.toFixed(1) : ""}</div></td>
                                <td><div className="goals center">{player.Stats.Goals == 0 ? (i<11||player.Stats.SubOut!=null ?"-":"") : player.Stats.Goals}</div></td>
                                <td><div className="assists center">{player.Stats.Assists == 0 ? (i<11||player.Stats.SubOut!=null ?"-":"") : player.Stats.Assists}</div></td>
                              </tr>
                            )}
                            <tr className="stat-manager">
                                <td colSpan={4} className="manager-col1">Менеджер:</td>
                                <td colSpan={4}>{this.props.teamManager}</td>
                            </tr>
                      </tbody>
                    </table>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    var team = ownProps.home == true ? state.HomeTeam : state.AwayTeam;
    return {
      teamName: team.Name,
      players: team.Players,
      position: state.statisticWindows[ownProps.id].position,
      is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
      back: team.Back,
      playerColor: team.Color,
      borderColor: team.Border,
      teamManager: team.manager.name
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayersStatsWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/PlayersStatsWindow.js
 **/